<template>
  <div class="project-card-container">
    <!-- 空状态：创建卡片居中 -->
    <div v-if="!projectList.length" class="empty-create-wrapper">
      <div class="card create-card create-card-center" @click="$emit('create')">
        <div class="create-card-inner">
          <div class="create-icon">
            <i class="el-icon-plus"></i>
          </div>
          <div class="create-title">创建新问卷</div>
          <div class="create-desc">点击这里快速创建一份新的调查问卷</div>
        </div>
      </div>
    </div>
    <!-- 有数据：网格布局，创建卡片顺延在最后 -->
    <div v-else class="card-grid">
      <!-- 问卷卡片列表 -->
      <div v-for="p in projectList" :key="p.id" class="card-wrapper">
        <div class="card">
          <div class="card-head">
            <div class="type-icon" :style="{ backgroundColor: getType(p.type).color }">
              <svg v-if="getTypeIcon(p.type).isSvg" class="svg-icon" aria-hidden="true">
                <use :xlink:href="'#' + getTypeIcon(p.type).icon"></use>
              </svg>
              <i v-else :class="getTypeIcon(p.type).icon"></i>
            </div>
            <div class="title-area">
              <div class="title">{{ p.textName | stripHtml }}</div>
              <div class="card-time">创建时间：{{ p.createTime | formatDate }}</div>
            </div>
            <span class="status-pill" :class="p.status == 2 ? 'published' : 'draft'">
              {{ p.status == 2 ? '已发布' : '未发布' }}
            </span>
          </div>
          <div class="card-actions">
            <i class="el-icon-edit-outline" @click="toProjectHandle(p, 'editor')"></i>
            <i class="el-icon-setting" @click="toProjectHandle(p, 'settings')"></i>
            <i class="el-icon-s-promotion" @click="toProjectHandle(p, 'publish')"></i>
            <i class="el-icon-data-analysis" @click="toProjectHandle(p, 'statistics')"></i>
            <i class="el-icon-share" @click="toProjectHandle(p, 'share')"></i>
            <el-dropdown class="more-btn" trigger="click" @command="(cmd)=>onMore(cmd,p)">
              <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                <el-dropdown-item command="stats"><i class="el-icon-data-analysis"></i> 统计</el-dropdown-item>
                <el-dropdown-item command="move"><i class="el-icon-rank"></i> 移动</el-dropdown-item>
                <el-dropdown-item command="pin"><i class="el-icon-thumb"></i> 置顶</el-dropdown-item>
                <el-dropdown-item command="copy"><i class="el-icon-document-copy"></i> 复制</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 创建新问卷卡片（顺延在最后） -->
      <div class="card-wrapper">
        <div class="card create-card" @click="$emit('create')">
          <div class="create-card-inner">
            <div class="create-icon">
              <i class="el-icon-plus"></i>
            </div>
            <div class="create-title">创建新问卷</div>
            <div class="create-desc">点击这里快速创建一份新的调查问卷</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'FormCardList',
  components: {},
  mixins: [mixin],
  props: {
    projectList: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  filters: {
    stripHtml(html) {
      if (!html) return ''
      const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim()
      return text.length > 20 ? text.substring(0, 20) + '...' : text
    }
  },
  computed: {
    isSingle(){
      return this.projectList && this.projectList.length === 1
    },
    getStatusColorStyle() {
      return function (code) {
        let color = this.projectStatusList.find((item) => item.code == code).color
        return {
          backgroundColor: color,
          borderColor: color
        }
      }
    },
    getFormStatusName() {
      return function (code) {
        let name = this.projectStatusList.find((item) => item.code == code).name
        let statusColor = this.projectStatusList.find((item) => item.code == code).color
        return {
          statusName: name,
          color: statusColor
        }
      }
    }
  },
  methods: {
    getTypeIcon(t){
      const type = parseInt(t) || 0
      if(type===3) return { isSvg: true, icon: 'icon-kaoshi' }
      if(type===4) return { isSvg: true, icon: 'icon-pingguchaxun' }
      if(type===2) return { isSvg: false, icon: 'el-icon-document-copy' }
      return { isSvg: false, icon: 'el-icon-edit-outline' }
    },
    deleteFrom(key) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.logicDeleteForm(key)
        })
        .catch(() => {})
    },
    onMore(cmd,p){
      if(cmd==='delete') return this.deleteFrom(p.id)
      if(cmd==='stats') return this.toProjectHandle(p,'statistics')
      if(cmd==='analysis') return this.toProjectHandle(p,'analysis')
      if(cmd==='copy') return this.handleCopyForm(p.formKey)
      if(cmd==='pin') return this.$message.success('已置顶')
      if(cmd==='move') return this.$message.success('移动到文件夹')
    },
    endEvent(event) {
      console.log(event)
    }
  }
}
</script>

<style lang="scss" scoped>
/* 容器 */
.project-card-container {
  margin: 0;
}

/* 空状态：居中展示创建卡片 */
.empty-create-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 20px;
}
.create-card-center {
  width: 280px;
  min-height: 200px;
  padding: 40px 24px !important;
}

/* 网格：4列等宽，自动换行 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  align-items: stretch;
}
.card-wrapper {
  display: flex;
}
.card-wrapper > .card {
  flex: 1;
}

/* 卡片 */
.card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 24px 20px 16px;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: default;
  display: flex;
  flex-direction: column;
}
.card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 创建新问卷卡片 */
.create-card {
  border: 2px dashed #c0d4f0 !important;
  background: #fafcff !important;
  box-shadow: none !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
  transition: all 0.25s ease;
}
.create-card:hover {
  border-color: #409eff !important;
  background: #f0f7ff !important;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.12) !important;
  transform: translateY(-2px);
}
.create-card-inner {
  text-align: center;
  padding: 12px 0;
}
.create-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #66b1ff);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  transition: transform 0.2s;
}
.create-card:hover .create-icon {
  transform: scale(1.1);
}
.create-icon i {
  font-size: 22px;
  color: #fff;
  font-weight: bold;
}
.create-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.create-desc {
  font-size: 12px;
  color: #a0a8b4;
  line-height: 1.5;
}

/* 头部：图标 + 标题 + 状态 */
.card-head {
  display: flex;
  align-items: flex-start;
}

/* 图标 */
.type-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #8BA4F8, #6E8BEE);
}
.type-icon .svg-icon {
  width: 18px;
  height: 18px;
  fill: #fff;
}

/* 标题区 */
.title-area {
  flex: 1;
  min-width: 0;
  margin-right: 8px;
}
.title {
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-time {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  white-space: nowrap;
}

/* 状态标签 */
.status-pill {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 1;
  padding: 4px 0;
}
.status-pill.published {
  color: #52c41a;
}
.status-pill.draft {
  color: #909399;
}

/* 底部操作栏 */
.card-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #f0f1f3;
  font-size: 16px;
  color: #c0c4cc;
}
.card-actions > i {
  cursor: pointer;
  transition: color 0.15s;
}
.card-actions > i:hover {
  color: #409eff;
}
.more-btn {
  margin-left: auto;
  cursor: pointer;
}
.more-btn i {
  color: #c0c4cc;
  transition: color 0.15s;
}
.more-btn i:hover {
  color: #409eff;
}

/* 空状态 */
.empty {
  padding: 40px;
  text-align: center;
  color: #909399;
}

/* 响应式 */
@media (max-width: 1200px) {
  .card-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
  .card-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
  .card-grid { grid-template-columns: 1fr; }
}
</style>
